module.exports = __webpack_public_path__ + "img/instagram.549663b4.svg";